import slice from "./areaHealthNewSlice";

export default slice.reducer;
